"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _Error = _interopRequireDefault(require("./../Messages/Error"));

var _Icons = require("../Icons");

var _Typography = require("../Typography");

var _DropDown$propTypes;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
    TODO:
    - Hide the menu on click outside of the element.
*/
var DropDown = function DropDown(_ref) {
  var name = _ref.name,
      onValueChange = _ref.onValueChange,
      children = _ref.children,
      dataTestId = _ref.dataTestId,
      options = _ref.options,
      value = _ref.value,
      error = _ref.error,
      disabled = _ref.disabled,
      className = _ref.className,
      otherProps = _ref.otherProps,
      placeholder = _ref.placeholder,
      opensUp = _ref.opensUp;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMenu = _useState2[0],
      setShowMenu = _useState2[1];

  var _useState3 = (0, _react.useState)(value),
      _useState4 = _slicedToArray(_useState3, 2),
      currentValue = _useState4[0],
      setCurrentValue = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      currentOption = _useState6[0],
      setCurrentOption = _useState6[1];

  var containerRef = (0, _react.useRef)();
  var inputRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var result = options.filter(function (obj) {
      return obj.value === currentValue;
    });
    setCurrentOption(result[0]);
  }, [currentValue]);

  var handleInputClickOutside = function handleInputClickOutside(e) {
    if (disabled || showMenu) return;

    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setShowMenu(false);
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleInputClickOutside, true);
    return function () {
      document.removeEventListener('click', handleInputClickOutside, true);
    };
  }, []);

  var handleInputClick = function handleInputClick() {
    if (!disabled) {
      setShowMenu(!showMenu);
    }
  };

  var handleInputKey = function handleInputKey(e) {
    if (!disabled) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        e.preventDefault();
        setShowMenu(!showMenu);
      }
    }
  };

  var handleInputKeyOption = function handleInputKeyOption(e, value) {
    if (!disabled) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        e.preventDefault();
        handleOptionClick(value);
      }
    }
  };

  var handleOptionClick = function handleOptionClick(chosenValue) {
    var result = options.filter(function (obj) {
      return obj.value === chosenValue;
    });
    onValueChange(result);
    setCurrentValue(result[0].value);
    inputRef.current.focus();
    setShowMenu(false);
  };

  return /*#__PURE__*/_react.default.createElement(DropDownWrapper, _extends({
    ref: containerRef,
    disabled: disabled,
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement(Label, {
    htmlFor: name
  }, children), /*#__PURE__*/_react.default.createElement(StyledDropDown, null, /*#__PURE__*/_react.default.createElement(Input, {
    error: error,
    ref: inputRef,
    onKeyDown: handleInputKey,
    tabIndex: "0",
    opensUp: opensUp,
    onClick: handleInputClick,
    show: showMenu,
    disabled: disabled,
    dataTestId: dataTestId
  }, currentOption ? currentOption === null || currentOption === void 0 ? void 0 : currentOption.title : placeholder, /*#__PURE__*/_react.default.createElement(DropDownIcon, null, /*#__PURE__*/_react.default.createElement(_Icons.IconChevronDown, {
    size: 25
  })), /*#__PURE__*/_react.default.createElement(StyledError, {
    error: error
  })), /*#__PURE__*/_react.default.createElement(Menu, {
    show: showMenu,
    opensUp: opensUp
  }, options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(MenuOption, {
      key: option.value,
      onKeyDown: function onKeyDown(e) {
        return handleInputKeyOption(e, option.value);
      },
      tabIndex: "0",
      onClick: function onClick() {
        return handleOptionClick(option.value);
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.H4, null, option.title), /*#__PURE__*/_react.default.createElement(_Typography.Body, {
      tiny: true,
      light: true
    }, option.text));
  }))));
};

var StyledError = (0, _styledComponents.default)(_Error.default).withConfig({
  displayName: "StyledError"
})(["position:absolute;top:100%;right:0;"]);

var DropDownWrapper = _styledComponents.default.div.withConfig({
  displayName: "DropDownWrapper"
})(["width:100%;max-width:100rem;z-index:9999;height:9rem;"]);

var Label = _styledComponents.default.label.withConfig({
  displayName: "Label"
})(["font-family:", ";font-size:1.4rem;line-height:2rem;letter-spacing:0.01em;color:#8990a3;margin-bottom:0.8rem;display:block;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var StyledDropDown = _styledComponents.default.div.withConfig({
  displayName: "StyledDropDown"
})(["position:relative;"]);

var Input = _styledComponents.default.div.withConfig({
  displayName: "Input"
})(["width:100%;height:4.5rem;border:1px solid ", ";background-color:", ";border-radius:", ";padding:1.2rem 1.8rem;display:flex;align-items:center;cursor:", ";font-family:", ";font-size:1.6rem;line-height:2rem;letter-spacing:0.02em;color:#222;transition:all .2s;&:focus{outline:0;border:1px solid ", ";}"], function (_ref3) {
  var error = _ref3.error;
  return error ? 'red' : '#e4e4e4';
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? '#E4E4E4' : 'white';
}, function (_ref5) {
  var show = _ref5.show,
      opensUp = _ref5.opensUp;
  return show && opensUp ? '0 0 5px 5px' : show ? '5px 5px 0 0' : '5px';
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.font;
}, function (_ref8) {
  var theme = _ref8.theme,
      disabled = _ref8.disabled;
  return !disabled ? theme.brand.primary : 'rgba(0,0,0,0)';
});

var DropDownIcon = _styledComponents.default.div.withConfig({
  displayName: "DropDownIcon"
})(["position:absolute;right:1.2rem;margin-top:0.1rem;> svg path{fill:#c1c1c1;}"]);

var Menu = _styledComponents.default.div.withConfig({
  displayName: "Menu"
})(["z-index:9999;visibility:", ";position:absolute;left:0;top:", ";bottom:", ";width:100%;max-height:", ";overflow-y:scroll;background-color:white;border:1px solid #e4e4e4;border-top:0;border-radius:", ";transition:max-height .2s ease,visibility .2s ease;"], function (_ref9) {
  var show = _ref9.show;
  return show ? 'visible' : 'hidden';
}, function (_ref10) {
  var opensUp = _ref10.opensUp;
  return opensUp ? 'auto' : '100%';
}, function (_ref11) {
  var opensUp = _ref11.opensUp;
  return opensUp ? '100%' : 'auto';
}, function (_ref12) {
  var show = _ref12.show;
  return show ? '30rem' : '0';
}, function (_ref13) {
  var opensUp = _ref13.opensUp;
  return opensUp ? '5px 5px 0 0' : '0 0 5px 5px';
});

var MenuOption = _styledComponents.default.div.withConfig({
  displayName: "MenuOption"
})(["padding:1.6rem;border-bottom:1px solid #e4e4e4;background-color:white;cursor:pointer;&:last-child{border-bottom:0;}&:hover{background-color:#f0f1f3;}&:focus{outline:none;border:1px solid ", ";}"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.brand.primary;
});

DropDown.propTypes = (_DropDown$propTypes = {
  // used to identify component for testing
  dataTestId: _propTypes.string,

  /** Name of the input */
  name: _propTypes.string.isRequired,

  /** Function that passes back the complete chosen option object. */
  onValueChange: _propTypes.func.isRequired,

  /** string with errormessage */
  error: _propTypes.string,

  /** label above the input */
  children: _propTypes.node.isRequired
}, _defineProperty(_DropDown$propTypes, "name", _propTypes.string.isRequired), _defineProperty(_DropDown$propTypes, "options", _propTypes.array.isRequired), _defineProperty(_DropDown$propTypes, "value", _propTypes.object), _defineProperty(_DropDown$propTypes, "disabled", _propTypes.bool), _defineProperty(_DropDown$propTypes, "className", _propTypes.string), _defineProperty(_DropDown$propTypes, "opensUp", _propTypes.string), _defineProperty(_DropDown$propTypes, "otherProps", _propTypes.object), _defineProperty(_DropDown$propTypes, "placeholder", _propTypes.string), _DropDown$propTypes);
var _default = DropDown;
exports.default = _default;